import type { components } from '@startech/openapi'

type ConversationWithFile = components['schemas']['ConversationWithFile']
type ConversationFile = NonNullable<ConversationWithFile['file']>

export const getConversationFiles = (conversation: ConversationWithFile | undefined): ConversationFile[] => {
  if (conversation?.files?.length) {
    return conversation.files
  }

  return conversation?.file ? [conversation.file] : []
}
